import NotifictionService from "../../services/NotifictionService";
import React, { useState } from "react";
import { Menu, Dropdown, Badge, Avatar, List, Button, Modal, message } from "antd";
import {
  MailOutlined,
  BellOutlined,
  WarningOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import Flex from "components/shared-components/Flex";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Loading from "../shared-components/Loading";

const getIcon = (icon) => {
  switch (icon) {
    case "mail":
      return <MailOutlined />;
    case "alert":
      return <WarningOutlined />;
    case "check":
      return <CheckCircleOutlined />;
    default:
      return <MailOutlined />;
  }
};

const getNotificationBody = (list) => {
  return list.length > 0 ? (
    <List
      size="small"
      itemLayout="horizontal"
      dataSource={list}
      renderItem={(item) => (
        <List.Item
          className="list-clickable"
          onClick={() => {
            NotifictionService.read(item.id);
            message.info('Find the details in the notifications list ')
          }}
        >
          <Flex alignItems="center">
            <div className="pr-3">
              {item.img ? (
                <Avatar src={`/img/avatars/${item.img}`} />
              ) : (
                <Avatar
                  className={`ant-avatar-${item.type}`}
                  icon={getIcon(item.icon)}
                />
              )}
            </div>
            <div className="mr-3">
              <span className="font-weight-bold text-dark">{item.name} : </span>
              <span className="text-gray-light">{item.desc}</span>
            </div>
            <small className="ml-auto">{item.time}</small>
          </Flex>
        </List.Item>
      )}
    />
  ) : (
    <div className="empty-notification">
      <img
        src="https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg"
        alt="empty"
      />
      <p className="mt-3">You have viewed all notifications</p>
    </div>
  );
};

export const NavNotification = () => {
  const queryClient = useQueryClient();
  const [visible, setVisible] = useState(false);
  const handleVisibleChange = (flag) => {
    setVisible(flag);
  };

  const { data = [], isLoading } = useQuery({
    queryKey: ["get_admin_notification"],
    queryFn: NotifictionService.getAdminNotification,
    refetchOnWindowFocus: true,
    select: (response) => response?.data ?? [],
  });

  const clearNotificationsMutation = useMutation({
    mutationFn: NotifictionService.clearAdminNotifications,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["get_admin_notification"],
      });
    },
  });

  const notificationList = (
    <div className="nav-dropdown nav-notification">
      <div className="nav-notification-header d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Notification</h4>
        <Button
          className="text-primary"
          type="link"
          onClick={() => {
            clearNotificationsMutation.mutate();
          }}
          size="small"
        >
          Clear
        </Button>
      </div>
      <div className="nav-notification-body">
        {getNotificationBody(data)}
      </div>
      {data.length > 0 ? (
        <div className="nav-notification-footer">
          <a className="d-block" href="#/">
            View all
          </a>
        </div>
      ) : null}
    </div>
  );
  if (isLoading) return <Loading cover={"content"} />;

  return (
    <>
      <Dropdown
        placement="bottomRight"
        overlay={notificationList}
        onVisibleChange={handleVisibleChange}
        visible={visible}
        trigger={["click"]}
      >
        <Menu mode="horizontal">
          <Menu.Item key="notification">
            <Badge count={data.length}>
              <BellOutlined className="nav-icon mx-auto" type="bell" />
            </Badge>
          </Menu.Item>
        </Menu>
      </Dropdown>
    </>
  );
};

export default NavNotification;
